export interface IMicrositeDetails {
    firstName: string,
    lastName: string,
    currentStatus: number,
    birthDate: string,
    transplantDate: string
}